import type { EconHeaderCountdownEvent } from "../../types/econ-header";
import { FadingRuler } from "../shared/FadingRuler";

export function ReleasedDeskPlanEvent({
  event,
}: {
  event: EconHeaderCountdownEvent | null;
}) {
  if (!event) {
    return (
      <div data-latest-econ-print-availability="unavailable">
        <p className="text-[11px] font-medium text-[var(--fintheon-text)]/72">
          No released Desk Plan event today
        </p>
        <p className="mt-1 text-[10px] leading-4 text-[var(--fintheon-text)]/46">
          The next released event will remain available here until local midnight.
        </p>
      </div>
    );
  }

  return (
    <div data-latest-econ-print-availability="available">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-[12px] font-medium text-[var(--fintheon-text)]">
            {event.eventName}
          </p>
          <p className="mt-0.5 truncate text-[9px] text-[var(--fintheon-text)]/40">
            Desk Plan
          </p>
        </div>
        <span className="shrink-0 font-mono text-[9px] text-[var(--fintheon-text)]/42">
          {formatTimestamp(event.actualPrintedAt ?? event.scheduledAt)}
        </span>
      </div>
      <div className="mt-3 flex items-stretch gap-2">
        <PrintValue label="Previous" value={event.previousValue} />
        <FadingRuler orientation="vertical" className="self-stretch opacity-35" />
        <PrintValue label="Forecast" value={event.calendarForecast} />
        <FadingRuler orientation="vertical" className="self-stretch opacity-35" />
        <PrintValue label="Actual" value={event.actualValue} accent />
      </div>
      {event.intelligence?.scoreImpact.rationale ? (
        <p className="mt-3 text-[10px] leading-4 text-[var(--fintheon-text)]/54">
          {event.intelligence.scoreImpact.rationale}
        </p>
      ) : null}
    </div>
  );
}

function PrintValue(input: {
  label: string;
  value: string | null;
  accent?: boolean;
}) {
  return (
    <div className="min-w-0 flex-1">
      <p className="text-[8px] uppercase tracking-[0.12em] text-[var(--fintheon-text)]/34">
        {input.label}
      </p>
      <p
        className={`mt-0.5 font-mono text-[12px] font-semibold ${
          input.accent
            ? "text-[var(--fintheon-accent)]"
            : "text-[var(--fintheon-text)]/72"
        }`}
      >
        {input.value ?? "—"}
      </p>
    </div>
  );
}

function formatTimestamp(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "time unknown";
  return parsed.toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
